/* eslint-disable react/prop-types */
/* eslint-disable no-useless-return */
/* eslint-disable arrow-body-style */
import React from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { useDispatch } from 'react-redux';
import { Form, Button, Segment, Label, Message, Icon, Header } from 'semantic-ui-react';
import { openModal } from '../../redux/modals/modalReducer';
import { cpgByComplaintId, noteByComplaintId } from '../../graphql/queries';

import ComplaintViewCPG from './include/ComplaintViewCPG';
import ComplaintViewNote from './include/ComplaintViewNote';
import ComplaintViewClient from './include/ComplaintViewClient';
import ComplaintViewAdmin from './include/ComplaintViewAdmin';

const ComplaintManagementDetail = ({ complaint, userList }) => {
  const dispatch = useDispatch();

  const {
    data: complaintCpgData,
    error: complaintCpgError,
    loading: complaintCpgLoading
  } = useQuery(cpgByComplaintId, {
    variables: { complaintId: complaint.confirmation },

    fetchPolicy: 'network-only'
  });

  const {
    data: complaintNoteData,
    error: complaintNoteError,
    loading: complaintNoteLoading
  } = useQuery(noteByComplaintId, {
    variables: { complaintId: complaint.confirmation },
    fetchPolicy: 'network-only'
  });

  const handleSubmit = () => {
    return;
  };

  return (
    <>
      {complaintCpgLoading && complaintNoteLoading && (
        <Message icon>
          <Icon name="circle notched" loading />
          <Message.Content>
            <Message.Header>Juste une seconde</Message.Header>
            Nous récupérons ce contenu pour vous.
          </Message.Content>
        </Message>
      )}
      {complaintCpgError && (
        <Message negative>
          <Message.Header>Erreur !!!</Message.Header>
          <p>Nous sommes désolés de ne pas pouvoir récuperer les informations</p>
          <p>{complaintCpgError.message}</p>
        </Message>
      )}

      {complaintNoteError && (
        <Message negative>
          <Message.Header>Erreur !!!</Message.Header>
          <p>Nous sommes désolés de ne pas pouvoir récuperer les informations</p>
          <p>{complaintNoteError.message}</p>
        </Message>
      )}

      <Message>
        <Header as="h2" color="blue">
          Detail de la plainte
        </Header>
      </Message>

      <Form size="large" onSubmit={handleSubmit}>
        <Segment.Group>
          <Segment color="blue">
            <Label as="a" color="blue" ribbon>
              Statut de la plainte
            </Label>

            {complaint && <ComplaintViewAdmin complaint={complaint} userList={userList} />}
          </Segment>
          <Segment color="blue">
            <Label as="a" color="blue" ribbon>
              Description de la plainte
            </Label>
            {complaint && <ComplaintViewClient complaint={complaint} />}
          </Segment>
          <Segment color="blue">
            <Label as="a" color="blue" ribbon>
              Action recommandée par le CGP
            </Label>

            {complaintCpgLoading && (
              <Message icon>
                <Icon name="circle notched" loading />
                <Message.Content>
                  <Message.Header>Juste une seconde</Message.Header>
                  Nous récupérons ce contenu pour vous.
                </Message.Content>
              </Message>
            )}

            <ComplaintViewCPG complaintCpgData={complaintCpgData} />
            <Button
              basic
              color="blue"
              onClick={() =>
                dispatch(
                  openModal({
                    modalType: 'ModalComplaintCPG',
                    modalProps: { complaint }
                  })
                )
              }
            >
              Ajouter une recommendation
            </Button>
          </Segment>

          <Segment color="blue">
            <Label as="a" color="blue" ribbon>
              Opinions conclusives du RQA
            </Label>
            {complaintNoteLoading && (
              <Message icon>
                <Icon name="circle notched" loading />
                <Message.Content>
                  <Message.Header>Juste une seconde</Message.Header>
                  Nous récupérons ce contenu pour vous.
                </Message.Content>
              </Message>
            )}
            <ComplaintViewNote complaintNoteData={complaintNoteData} />
            <Button
              basic
              color="blue"
              onClick={() =>
                dispatch(
                  openModal({
                    modalType: 'ModalComplaintNote',
                    modalProps: { complaint }
                  })
                )
              }
            >
              Ajouter une opinion conclusive
            </Button>
          </Segment>

          <Segment textAlign="center">
            <Button.Group>
              <Button
                fluid
                type="submit"
                floated="right"
                positive
                content="Fermer"
                as={Link}
                to="/dashboard/admin-complaints"
              />
            </Button.Group>
          </Segment>
        </Segment.Group>
      </Form>
    </>
  );
};

export default ComplaintManagementDetail;
